import { render, staticRenderFns } from "./House.vue?vue&type=template&id=52ba044a&scoped=true&"
import script from "./House.js?vue&type=script&lang=js&"
export * from "./House.js?vue&type=script&lang=js&"
import style0 from "./House.vue?vue&type=style&index=0&lang=css&"
import style1 from "./House.scss?vue&type=style&index=1&id=52ba044a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ba044a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
